import { createAction, createSlice } from '@reduxjs/toolkit';

export type StaffData = {
	'employeeName': string,
	'imageUrl': string,
	'description': string,
	'dateOfJoining': string,
	'buzzBoardId': string,
	'buzzType': string,
}

const initialState: StaffData[] = [];

export const revertAll = createAction('REVERT_ALL');

export const staffReducer = createSlice({
	name: 'staffReducer',
	initialState,
	reducers: {
		setStaffData: (state, action) => {
			state = action.payload;
			return state;
		},
		addStaffData: (state, action) => {
			state = [action.payload, ...state];
			return state;
		},
		updateStaffData: (state, action) => {

			const indexOfReportToChange = state.findIndex(data => data.buzzBoardId === action.payload.buzzBoardId);
			const changedStaffData = action.payload;

			state[indexOfReportToChange] = changedStaffData;
			return state;
		},
		deleteStaffData: (state, action) => {

			const indexOfStaffDataToDelete = state.findIndex(data => data.buzzBoardId === action.payload.buzzBoardId);

			if (indexOfStaffDataToDelete !== -1) {

				const savedData = state;
				state = [
					...savedData.slice(0, indexOfStaffDataToDelete),
					...savedData.slice(indexOfStaffDataToDelete + 1)];
			}
			return state;
		}

	}

});
export const { setStaffData, addStaffData, updateStaffData, deleteStaffData } = staffReducer.actions;
export default staffReducer;
